import {map} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {EfsReportFormComponent} from '../form/EfsReportFormComponent';
import {BehaviorSubject, Observable} from 'rxjs';
import {EfsReport} from '../../../../../services/api.client';
import {formatDate} from '../../../../../utilities/date-util';
import {DATE_TIME_FORMAT} from '../../../../../constants';

@Component({
    templateUrl: './EfsReportComponent.html',
    standalone: false
})
export class EfsReportComponent implements OnInit {

    tableHeaders: ITableHeader[] = [
        {text: 'Entry Date'},
        {text: 'First Name'},
        {text: 'Last Name'},
        {text: 'SSN'},
        {text: 'Cycle'},
        {text: 'Assistance Type'},
        {text: 'Agency'},
        {text: 'Zip Code'},
    ];

    @ViewChild('form')
    form: EfsReportFormComponent;

    private readonly _report$ = new BehaviorSubject<EfsReport[]>(null);
    report$: Observable<EfsReport[]> = this._report$.asObservable();
    rows: Observable<(string | number)[][]>;

    ngOnInit(): void {
        this.rows = this.report$
            .exists().pipe(
                map((report) => report.map(r => [
                    formatDate(r.enteredDate, DATE_TIME_FORMAT),
                    r.clientFirstName,
                    r.clientLastName,
                    '***-**-' + r.clientLast4Ssn || 'no SSN',
                    r.pledgeTypeName,
                    r.assistanceType,
                    r.agencyName,
                    r.zipCode
                ])));
    }

    submitReport(): void {
        this.form.submitEfsReport().subscribe({next: (report) => this._report$.next(report), error: () => {}});
    }
}
